export const applicationMostHelpfulAndUnHelpfulReviewCountsQueryKey =
  "MostHelpfulAndUnHelpfulReviewCounts";
